import { render, staticRenderFns } from "./BIParametersTab.vue?vue&type=template&id=78f26b2a&"
import script from "./BIParametersTab.vue?vue&type=script&lang=js&"
export * from "./BIParametersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports